/* Per-auction registration MODAL (Phase 2). Global, self-contained — sibling to the phone
   verify modal. window.MHVAuctionRegister.open({ auctionCode, onRegistered }) pops a modal that
   bootstraps from /auction-register/context, vaults a card via Square Web Payments, captures
   fulfillment + auto-charge consent, and POSTs /auction-register. Uses window.mhvFetch
   (X-Customer-Key) + window.MHVVerify (phone gate).

   Address UX (saved-address picker + add/edit + Google Places autocomplete) and the Square
   card trust line MIRROR the custom checkout page (mhv-checkout.js) so the two surfaces match.
   Saved addresses are injected from Liquid via window.MHV_AUCTION_REGISTER_ADDRESSES (same as
   checkout gets customer.addresses); add/edit/delete/set-default reuse the account endpoints. */
(function () {
  'use strict';
  var SERVER = (window.MHV && window.MHV.SERVER_URL) || 'https://mhv-viewer-app-1df0c0c61ed9.herokuapp.com';
  var esc = (window.MHV && window.MHV.escapeHtml) ? window.MHV.escapeHtml : function (s) { return String(s == null ? '' : s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); };
  var escAttr = (window.MHV && window.MHV.escapeAttr) ? window.MHV.escapeAttr : function (s) { return esc(s).replace(/"/g, '&quot;').replace(/'/g, '&#39;'); };

  var STATES = ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC'];
  var SQUARE_LOGO = 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/Square_Logo_2025_Black.png?v=1782405898';
  // Pickup locations mirror the custom-checkout page (same values + labels + addresses).
  var PICKUP_LOCATIONS = [
    ['franklin_nh', 'Franklin, NH', '58 South Main St'],
    ['jaffrey_nh', 'Jaffrey, NH', '385 Squantum Rd']
  ];

  // Saved addresses + identity injected by Liquid (theme.liquid) — same source checkout uses.
  var INJECTED_ADDRS = window.MHV_AUCTION_REGISTER_ADDRESSES || [];
  var DEFAULT_ADDR_ID = (typeof window.MHV_AUCTION_REGISTER_DEFAULT_ADDRESS_ID !== 'undefined') ? window.MHV_AUCTION_REGISTER_DEFAULT_ADDRESS_ID : null;
  var CUST = window.MHV_AUCTION_REGISTER_CUSTOMER || {};

  var els = null;
  var state = {};

  function api(path, opts) {
    return window.mhvFetch(SERVER + path, opts).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; }); });
  }
  function loadScript(src) {
    return new Promise(function (res, rej) {
      if (document.querySelector('script[src="' + src + '"]')) return res();
      var s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = function () { rej(new Error('load failed')); }; document.head.appendChild(s);
    });
  }
  function q(sel) { return els.card.querySelector(sel); }
  function qa(sel) { return els.card.querySelectorAll(sel); }
  function byId(id) { return document.getElementById(id); }
  function val(id) { var e = byId(id); return e ? e.value.trim() : ''; }
  function formatPhone(p) {
    var d = String(p || '').replace(/\D/g, '');
    if (d.length === 11 && d[0] === '1') d = d.slice(1);
    if (d.length === 10) return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
    return String(p || '');
  }

  function ensureDom() {
    if (els) return;
    var ov = document.createElement('div'); ov.id = 'mhv-areg-overlay';
    ov.innerHTML =
      '<div class="areg-card" role="dialog" aria-modal="true" aria-labelledby="areg-title">' +
        '<button type="button" class="areg-close" aria-label="Close">&times;</button>' +
        '<h2 class="areg-title" id="areg-title">Register for this auction</h2>' +
        '<p class="areg-tagline">One-time per auction — confirm delivery and put a card on file.</p>' +
        '<div class="areg-err" id="areg-err" style="display:none"></div>' +
        '<div class="areg-loading" id="areg-loading">Loading…</div>' +
        '<div id="areg-body"></div>' +
        '<div class="areg-done" id="areg-done" style="display:none">' +
          '<div class="areg-done-ico">✓</div><h3>You’re registered!</h3>' +
          '<div id="areg-done-msg" class="areg-done-msg"></div><button type="button" class="areg-btn" id="areg-done-ok">Done</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ov);
    els = { ov: ov, card: ov.querySelector('.areg-card'), body: ov.querySelector('#areg-body'),
      err: ov.querySelector('#areg-err'), loading: ov.querySelector('#areg-loading'),
      title: ov.querySelector('#areg-title'), tagline: ov.querySelector('.areg-tagline'),
      done: ov.querySelector('#areg-done'), doneMsg: ov.querySelector('#areg-done-msg') };
    ov.querySelector('.areg-close').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    // close() now fires onRegistered itself (once), so this just dismisses.
    ov.querySelector('#areg-done-ok').addEventListener('click', function () { close(); });
  }

  function showError(msg) { els.err.textContent = msg || ''; els.err.style.display = msg ? 'block' : 'none'; if (msg) els.card.scrollTop = 0; }

  // Show the success/registered card ALONE — hide the "Register for this auction"
  // header + tagline + form so the done state reads clean (not stacked under the
  // register prompt). Header is restored on reopen / "Update my registration".
  function showDone() {
    // Registration succeeded — close() will fire onRegistered however the modal is
    // dismissed (Done, ✕ or backdrop). See close().
    if (state) state.registered = true;
    if (els.title) els.title.style.display = 'none';
    if (els.tagline) els.tagline.style.display = 'none';
    els.body.style.display = 'none';
    els.loading.style.display = 'none';
    els.err.style.display = 'none';
    els.done.style.display = 'block';
  }
  function showHeader() {
    if (els.title) els.title.style.display = '';
    if (els.tagline) els.tagline.style.display = '';
  }

  function open(opts) {
    opts = opts || {};
    ensureDom();
    // `edit` — go STRAIGHT to the form even for somebody already registered, and
    // `notice` — say why. Both exist for the hub's restriction modal: a bidder sent
    // here to change their delivery choice so they can bid on one lot must not land
    // on "You're registered for this auction" and have to find the Update link.
    // ⚠️ EVERY CHOICE STARTS EMPTY (2026-10-09). This used to open on fulfillment
    // 'shipping', the first saved card and end-of-auction timing, so anybody who did
    // not read the form top to bottom registered for whatever was already lit — most
    // often shipping. A choice is filled in only by (a) the bidder, (b) their own
    // existing registration, or (c) there being exactly ONE option.
    state = { auction: String(opts.auctionCode || '').trim(), onRegistered: opts.onRegistered || null,
      editMode: opts.edit === true, notice: opts.notice || null, flash: opts.flash || null,
      openOpts: { auctionCode: opts.auctionCode, onRegistered: opts.onRegistered, edit: opts.edit, notice: opts.notice },
      fulfillment: null, method: null, pickupLocation: null, pickupSlot: null, timing: null, cardChoice: null,
      rsvp: null, rsvpTouched: false, steps: [], done: {}, openStep: null,
      sq: { ready: false }, submitting: false, ctx: null, sqcfg: null,
      addresses: [], defaultAddrId: null, shippingAddressId: null, oneOffAddress: null, forcedAutoCharge: false };
    els.err.style.display = 'none'; els.body.innerHTML = ''; els.body.style.display = 'none';
    els.done.style.display = 'none'; els.loading.style.display = 'block'; showHeader();
    if (els.title) els.title.textContent = 'Register for this auction';
    els.ov.classList.add('areg-open'); document.documentElement.style.overflow = 'hidden';
    if (!state.auction) { els.loading.style.display = 'none'; showError('No auction was specified.'); return; }

    var ready = window.MHV_CUSTOMER_KEY_READY || Promise.resolve();
    ready.then(function () {
      return Promise.all([
        api('/checkout/config').catch(function () { return { data: {} }; }),
        api('/auction-register/context?auction=' + encodeURIComponent(state.auction))
      ]);
    }).then(function (rs) {
      state.sqcfg = (rs[0] && rs[0].data) || {};
      var cr = rs[1];
      els.loading.style.display = 'none';
      if (!cr.ok) { showError((cr.data && cr.data.error) || 'Could not load registration.'); return; }
      state.ctx = cr.data;
      if (state.ctx.phoneVerified === false) return renderPhoneGate();
      // First-time buyers are FORCED into end-of-auction auto-charge — they never reach the
      // manual checkout, so we drop "…at checkout" copy for them (returning grace_4day keeps it).
      // That is one option, not a default, so it is the only timing ever filled in for them.
      if (state.ctx.isFirstTime) state.timing = 'end_of_auction';
      state.forcedAutoCharge = state.ctx.isFirstTime === true;
      loadAddresses();
      // Reopening a registration shows what they chose. That is their answer on
      // record, not a default — and a bidder sent here to change ONE thing must not
      // find the other things quietly swapped for the first option on the list.
      prefillFromExisting();
      if (state.ctx.registered && !state.editMode) return renderRegistered();
      renderForm();
    }).catch(function () { els.loading.style.display = 'none'; showError('Could not load registration. Please try again.'); });
  }

  // ⚠️ Fire onRegistered on ANY close once registration succeeded — not only from the
  // "Done" button. The bid gate uses that callback to clear html.mhv-reg-required,
  // which is what un-hides the bidding UI (and to retry a bid that hit the 403). A
  // bidder who registered successfully and then dismissed the modal with ✕ or a
  // backdrop click was left with the bid form still hidden and had to reload the page
  // to bid. Guarded so it can only fire once. (Deep audit 2026-08-14.)
  function close() {
    if (els) els.ov.classList.remove('areg-open');
    document.documentElement.style.overflow = '';
    if (state && state.registered && !state.registeredFired) {
      state.registeredFired = true;
      var cb = state.onRegistered;
      if (cb) { try { cb(); } catch (e) { /* caller's problem, not ours */ } }
    }
  }

  function renderPhoneGate() {
    els.body.style.display = 'block';
    els.body.innerHTML = '<p class="areg-muted">Before registering, please verify your phone number — it only takes a second.</p>' +
      '<button type="button" class="areg-btn" id="areg-verify-btn">Verify my phone</button>';
    q('#areg-verify-btn').addEventListener('click', function () {
      if (window.MHVVerify) window.MHVVerify.open({ message: 'Verify your phone number to register for this auction.', onVerified: function () { open({ auctionCode: state.auction, onRegistered: state.onRegistered }); } });
      else showError('Phone verification is unavailable right now.');
    });
  }

  // Already registered. The choices on record are listed in the SAME rows the
  // stepped form ends on, so "what did I pick?" and "change it" are one glance and
  // one tap — "Update my registration" with nothing visible to update is a button
  // nobody presses deliberately, and the delivery choice is exactly what a bidder
  // comes back to change once a lot is grayed out.
  function renderRegistered() {
    var ex = state.ctx.existing || {};
    showDone();
    els.doneMsg.innerHTML = 'You’re registered for this auction.' +
      '<div class="areg-review areg-review--done">' + reviewRowsHtml(false) + '</div>' +
      '<button type="button" class="areg-btn areg-btn-secondary" id="areg-update">Change my registration</button>';
    var u = els.done.querySelector('#areg-update');
    if (u) u.addEventListener('click', function () { els.done.style.display = 'none'; showHeader(); renderForm(); });
    if (!ex.fulfillment && !ex.cardLast4) els.doneMsg.querySelector('.areg-review').style.display = 'none';
  }

  // ---------------------------------------------------------------------------
  // Saved addresses (mirrors checkout's model: normalized {id, firstName, …,
  // provinceCode, isDefault}). Source = Liquid-injected customer.addresses.
  // ---------------------------------------------------------------------------
  function normInjectedAddr(a) {
    a = a || {};
    return { id: a.id != null ? String(a.id) : '', firstName: a.first_name || '', lastName: a.last_name || '',
      address1: a.address1 || '', address2: a.address2 || '', city: a.city || '',
      provinceCode: a.province_code || a.province || '', zip: a.zip || '', phone: a.phone || '',
      country: a.country_code || 'US', isDefault: DEFAULT_ADDR_ID != null && String(a.id) === String(DEFAULT_ADDR_ID) };
  }
  function normShopifyAddr(ca) { // ca = customer_address returned by the account endpoints
    ca = ca || {};
    return { id: ca.id != null ? String(ca.id) : '', firstName: ca.first_name || '', lastName: ca.last_name || '',
      address1: ca.address1 || '', address2: ca.address2 || '', city: ca.city || '',
      provinceCode: ca.province_code || ca.province || '', zip: ca.zip || '', phone: ca.phone || '',
      country: ca.country_code || 'US', isDefault: !!ca.default };
  }
  function normCtxAddr(a) { // context.defaultAddress is already camelCase
    a = a || {};
    return { _oneOff: true, id: null, isDefault: false, firstName: a.firstName || '', lastName: a.lastName || '',
      address1: a.address1 || '', address2: a.address2 || '', city: a.city || '',
      provinceCode: a.province || a.provinceCode || '', zip: a.zip || '', phone: a.phone || '', country: a.country || 'US' };
  }
  function loadAddresses() {
    state.addresses = (INJECTED_ADDRS || []).map(normInjectedAddr).filter(function (a) { return a.id; });
    state.defaultAddrId = DEFAULT_ADDR_ID != null ? String(DEFAULT_ADDR_ID) : null;
    var def = state.addresses.filter(function (a) { return a.isDefault; })[0] || state.addresses[0] || null;
    if (def) { state.shippingAddressId = def.id; state.oneOffAddress = null; }
    else if (state.ctx && state.ctx.defaultAddress && state.ctx.defaultAddress.address1) {
      state.oneOffAddress = normCtxAddr(state.ctx.defaultAddress);
    }
  }
  function currentShipAddr() {
    if (state.oneOffAddress) return state.oneOffAddress;
    return state.addresses.filter(function (a) { return a.id === state.shippingAddressId; })[0] || null;
  }
  function applyDefault(id) {
    id = String(id);
    state.addresses.forEach(function (a) { a.isDefault = a.id === id; });
    state.defaultAddrId = id;
  }

  function timingConsentText() {
    if (state.ctx.isFirstTime) return 'I understand my card will be automatically charged at the end of this auction for my winning bids and associated charges.';
    if (state.timing === 'grace_4day') return 'I understand I have 4 days from when my invoice is issued to pay on my own, after which Granite Union Auction Co. will automatically charge the card on file for any unpaid balance, including shipping.';
    if (state.timing === 'pay_in_person') return 'I understand I will pay by cash or check when I collect my winnings, and that if I have not collected and paid within one week of the auction, Granite Union Auction Co. will automatically charge the card on file for any unpaid balance.';
    return 'I understand and authorize Granite Union Auction Co. to automatically charge my card at the end of this auction for my winning bids and associated charges.';
  }
  // The card authorization names what the bidder actually chose. It used to say
  // "shipping (if I choose shipping)" to everybody — we know what they chose.
  function cardAuthText() {
    var what = state.fulfillment === 'shipping'
      ? 'winning bids, the buyer’s premium, shipping to the address I chose, and any applicable taxes or fees'
      : state.fulfillment === 'openbox'
        ? 'winning bids, the buyer’s premium, shipping when my Open Box is closed and shipped, and any applicable taxes or fees'
        : 'winning bids, the buyer’s premium, and any applicable taxes or fees';
    return 'I authorize Granite Union Auction Co. to securely store my payment card (via our payment processor, Square) and to charge that card for all amounts I owe from this auction — including ' + what + '.';
  }
  function cardLockText() {
    var base = 'I understand that once I register for this auction, the card on file is locked for this auction and cannot be removed or replaced';
    return state.forcedAutoCharge ? (base + '.') : (base + ' (I may still choose a different card when I check out and pay).');
  }

  // In-person auction with a set date → offer "take it home on auction day".
  function inPersonAuctionDayOffered() {
    var ev = state.ctx && state.ctx.event;
    return !!(ev && ev.inPerson && ev.eventDate);
  }
  function venueKey() {
    var ev = state.ctx && state.ctx.event;
    return (ev && ev.location === 'jaffrey') ? 'jaffrey_nh' : 'franklin_nh';
  }
  // The slot an auction-day choice submits. The server pins date/venue from the event
  // row regardless; this is so the form can show the choice and the update path can
  // recognise it.
  function auctionDaySlot() {
    var ev = state.ctx.event;
    return { date: ev.eventDate, start: ev.startTime || null, end: null, location: ev.location || null, locationDetail: 'At the auction', flexible: false, auctionDay: true };
  }
  function fmtEventDay() {
    var ev = state.ctx && state.ctx.event; if (!ev || !ev.eventDate) return 'auction day';
    var p = String(ev.eventDate).split('-'); var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return days[d.getUTCDay()] + ' ' + months[d.getUTCMonth()] + ' ' + d.getUTCDate();
  }

  function fmtEventWhen() {
    var ev = state.ctx && state.ctx.event; if (!ev || !ev.eventDate) return '';
    var p = String(ev.eventDate).split('-'); var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var out = days[d.getUTCDay()] + ', ' + months[d.getUTCMonth()] + ' ' + d.getUTCDate();
    if (ev.startTime) {
      var t = String(ev.startTime).split(':'), h = +t[0];
      if (!isNaN(h)) out += ' at ' + ((h % 12) || 12) + ':' + (t[1] || '00').slice(0, 2) + ' ' + (h < 12 ? 'AM' : 'PM');
    }
    return out;
  }

  // ── "AVAILABLE FOR 42 OF 180 LOTS" ─────────────────────────────────────────
  // An in-person sale that offers shipping because SOME of its lots ship must not
  // read as though the whole catalogue does — that is the misunderstanding the
  // grayed-out lots on the hub would then have to correct, one lot at a time.
  // Absent counts (an auction with no catalogue yet) print nothing rather than a
  // guess.
  function lotCounts() { return (state.ctx && state.ctx.event && state.ctx.event.lotFulfillment) || null; }
  function shipCaveat() {
    var lc = lotCounts();
    if (!lc || !lc.total || !lc.mixedShipping) return '';
    return ' Available for ' + lc.shipping.lots + ' of ' + lc.total + ' lots.';
  }
  function pickupCaveat(key) {
    var lc = lotCounts();
    if (!lc || !lc.total) return '';
    var n = lc.pickup && lc.pickup[key] ? lc.pickup[key].lots : null;
    if (n == null || n >= lc.total) return '';    // covers everything — nothing to caveat
    return ' ' + n + ' of ' + lc.total + ' lots.';
  }
  // Why the bidder is being shown this form (set by the hub's restriction modal).
  function noticeHtml() {
    if (!state.notice) return '';
    return '<div class="areg-callout areg-callout--notice">' + esc(state.notice) + '</div>';
  }

  // ===========================================================================
  // THE FORM IS A SEQUENCE OF STEPS (2026-10-09) — the custom checkout's design.
  //
  // It used to be one long page: identity, delivery, RSVP, card, timing and four
  // authorizations all open at once, with a delivery method already lit. People who
  // did not read it top to bottom registered for whatever was pre-selected — most
  // often SHIPPING — and the first anyone learned of it was an invoice with postage
  // on it. So, like /pages/checkout:
  //   • one numbered section open at a time; finishing it ("Continue") opens the next;
  //   • a section you have not reached cannot be opened, so nothing is skipped past;
  //   • NOTHING IS PRE-SELECTED unless it is the only option (or it is the bidder's
  //     own answer on an existing registration);
  //   • a finished section shows its answer on its header, and changing an answer
  //     re-opens that section until "Continue" is pressed again;
  //   • the last section reviews every answer, each with a Change link, above the
  //     authorizations and the button.
  // The SAME form is the "change my registration" modal: an existing registration
  // opens with every step it can fill already finished, on the review.
  // ===========================================================================

  var CARET_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function locShort(k) { k = String(k || '').replace(/_nh$/, ''); return k === 'jaffrey' ? 'Jaffrey' : k === 'onsite' ? 'Onsite' : k === 'franklin' ? 'Franklin' : ''; }
  function locLabel(k) { k = String(k || '').replace(/_nh$/, ''); return k === 'jaffrey' ? 'Jaffrey, NH' : k === 'onsite' ? 'Onsite' : 'Franklin, NH'; }
  function locAddr(k) {
    if (k === 'onsite') return (state.ctx && state.ctx.event && state.ctx.event.onsiteAddress) || '';
    var row = PICKUP_LOCATIONS.filter(function (l) { return l[0] === k; })[0];
    return row ? row[2] : '';
  }
  // A stored location may be 'franklin' or 'franklin_nh' — the form speaks the latter.
  function normLocKey(k) {
    k = String(k || '').toLowerCase();
    if (k.indexOf('franklin') >= 0) return 'franklin_nh';
    if (k.indexOf('jaffrey') >= 0) return 'jaffrey_nh';
    if (k.indexOf('onsite') >= 0) return 'onsite';
    return null;
  }

  // ── What THIS auction offers ──────────────────────────────────────────────
  function shippingOffered() { var ev = (state.ctx && state.ctx.event) || {}; return ev.shippingOffered !== false; }
  // Ordered as the checkout orders them: Pickup, Shipping, Open Box.
  // Somebody coming to a dated in-person sale is asked one thing: collect on the
  // day, or later. Everybody else gets pickup / shipping / Open Box.
  function yesMode() { return inPersonAuctionDayOffered() && state.rsvp === 'yes'; }
  function methodOptions() {
    if (yesMode()) return ['auctionday', 'pickup'];
    return shippingOffered() ? ['pickup', 'shipping', 'openbox'] : ['pickup'];
  }
  // The pickup locations a bidder can actually pick. Unconfigured → both buildings
  // (don't over-restrict); an onsite-only sale → onsite.
  function offeredPickupLocs() {
    var locs = (state.ctx && state.ctx.event && state.ctx.event.pickupLocations) || [];
    var keys = PICKUP_LOCATIONS.filter(function (l) { return !locs.length || locs.indexOf(l[0].replace('_nh', '')) !== -1; })
      .map(function (l) { return l[0]; });
    if (!keys.length && locs.indexOf('onsite') !== -1) return ['onsite'];
    return keys;
  }

  // ── Filling in answers: theirs, or the only one there is ─────────────────
  function prefillFromExisting() {
    var ex = state.ctx.existing;
    var mem = !ex ? state.ctx.remembered : null;
    var src = ex || mem;
    if (src) {
      // Their RSVP. One on record is shown but only RE-SENT if they tap it
      // (rsvpTouched) — a count should only move on a deliberate answer; a
      // remembered one IS a deliberate answer for this new sale, so it is sent.
      if (ex) { if (state.ctx.rsvp) state.rsvp = state.ctx.rsvp; }
      else if (mem.rsvp && state.ctx.event && state.ctx.event.inPerson) { state.rsvp = mem.rsvp; state.rsvpTouched = true; }
      var wasAuctionDay = ex ? !!(ex.pickupSlot && ex.pickupSlot.auctionDay) : !!mem.auctionDay;
      if (wasAuctionDay && inPersonAuctionDayOffered()) {
        state.rsvp = 'yes'; if (mem) state.rsvpTouched = true;
        state.method = 'auctionday'; state.fulfillment = 'pickup';
        state.pickupLocation = venueKey(); state.pickupSlot = auctionDaySlot();
      } else if (src.fulfillment) {
        state.method = src.fulfillment; state.fulfillment = src.fulfillment;
        if (src.fulfillment === 'pickup') {
          state.pickupLocation = normLocKey(src.pickupLocation);
          if (ex && ex.pickupSlot && !ex.pickupSlot.auctionDay) state.pickupSlot = ex.pickupSlot;
          // A remembered pickup never carries a DAY — that belonged to another sale.
          else if (mem && state.pickupLocation) state.pickupSlot = { flexible: true, location: state.pickupLocation };
        }
        // "Coming in person" now means collecting in person; an old registration
        // that paired it with shipping asks the RSVP again rather than guessing.
        if ((src.fulfillment === 'shipping' || src.fulfillment === 'openbox') && state.rsvp === 'yes' && inPersonAuctionDayOffered()) { state.rsvp = null; state.rsvpTouched = false; }
      }
      if (!state.ctx.isFirstTime && ['end_of_auction', 'grace_4day', 'pay_in_person'].indexOf(src.autoChargeMode) !== -1) state.timing = src.autoChargeMode;
      var cards = state.ctx.savedCards || [];
      if (src.savedCardId != null && cards.some(function (c) { return String(c.id) === String(src.savedCardId); })) state.cardChoice = String(src.savedCardId);
      if (src.fulfillment === 'shipping') {
        var sid = src.shippingAddressId != null ? String(src.shippingAddressId) : '';
        if (sid && state.addresses.some(function (a) { return a.id === sid; })) { state.shippingAddressId = sid; state.oneOffAddress = null; }
        else if (src.shippingAddress && src.shippingAddress.address1) {
          state.oneOffAddress = normCtxAddr(src.shippingAddress);
          if (ex) state.oneOffAddress._onRecord = true; else state.oneOffAddress._remembered = true;
        }
      }
      if (mem) state.rememberedApplied = true;
    }
    // A choice this sale does not offer is dropped, never shown as chosen.
    if (state.method && methodOptions().indexOf(state.method) === -1) { state.method = null; state.fulfillment = null; state.pickupLocation = null; state.pickupSlot = null; }
    if (state.pickupLocation && state.method !== 'auctionday' && offeredPickupLocs().indexOf(state.pickupLocation) === -1) { state.pickupLocation = null; state.pickupSlot = null; }
    if (state.timing === 'pay_in_person' && state.fulfillment !== 'pickup') state.timing = null;
    applySingleOptions();
  }
  // Exactly one option → it is the answer. Two or more → the bidder chooses.
  function singleMethod() { var m = methodOptions(); return m.length === 1 ? m[0] : null; }
  function applySingleOptions() {
    if (!state.method && singleMethod()) { state.method = singleMethod(); state.fulfillment = state.method; }
    if (state.fulfillment === 'pickup' && !state.pickupLocation) {
      var locs = offeredPickupLocs(); if (locs.length === 1) state.pickupLocation = locs[0];
    }
    if (!state.cardChoice && !(state.ctx.savedCards || []).length) state.cardChoice = 'new';
    if (state.ctx.isFirstTime) state.timing = 'end_of_auction';
  }

  // ── The steps ────────────────────────────────────────────────────────────
  function buildSteps() {
    var ev = (state.ctx && state.ctx.event) || {};
    var rsvpFirst = inPersonAuctionDayOffered();   // the answer decides the delivery step
    var s = [];
    // Step 1 is the sale itself (owner, 2026-10-13): its day and place and, for an
    // in-person sale, the loud line saying there is no live online bidding.
    if (infoBodyHtml()) s.push('info');
    if (bidderBlockHtml()) s.push('identity');
    if (ev.inPerson && rsvpFirst) s.push('rsvp');
    s.push('delivery');
    if (ev.inPerson && !rsvpFirst) s.push('rsvp');
    s.push('card');
    s.push('timing');   // first-time buyers see it too — locked, with the rule explained
    s.push('auth');
    s.push('confirm');
    return s;
  }
  function stepTitle(k) {
    var ev = (state.ctx && state.ctx.event) || {};
    if (k === 'info') return 'Auction info';
    if (k === 'identity') return 'Bidding as';
    if (k === 'rsvp') return 'Coming in person?';
    if (k === 'delivery') return ev.inPerson ? 'Your winnings' : (shippingOffered() ? 'Shipping & Pickup' : 'Pickup');
    if (k === 'card') return 'Card on file';
    if (k === 'timing') return 'Payment timing';
    if (k === 'auth') return 'Authorizations';
    return isUpdating() ? 'Review & update' : 'Review & register';
  }
  function deliveryComplete() {
    if (state.method === 'auctionday' || state.method === 'openbox') return true;
    if (state.method === 'shipping') { var a = currentShipAddr(); return !!(a && a.address1 && a.city && a.provinceCode && a.zip); }
    if (state.method === 'pickup') return !!state.pickupLocation;
    return false;
  }
  function stepComplete(k) {
    if (k === 'info' || k === 'identity') return true;
    if (k === 'rsvp') return !!state.rsvp;
    if (k === 'delivery') return deliveryComplete();
    if (k === 'card') return !!state.cardChoice && (state.cardChoice !== 'new' || !!state.sq.ready);
    if (k === 'timing') return !!state.timing;
    if (k === 'auth') return authComplete();
    return false;
  }
  function authComplete() {
    var boxes = qa('#areg-checks input[data-consent]');
    if (boxes.length !== 4) return false;
    for (var i = 0; i < boxes.length; i++) if (!boxes[i].checked) return false;
    return true;
  }
  function stepReachable(k) {
    var i = state.steps.indexOf(k);
    for (var j = 0; j < i; j++) if (!state.done[state.steps[j]]) return false;
    return i !== -1;
  }
  function nextStep() {
    for (var i = 0; i < state.steps.length; i++) { var k = state.steps[i]; if (k !== 'confirm' && !state.done[k]) return k; }
    return 'confirm';
  }
  // A change to an answer re-opens its step until "Continue" is pressed again —
  // nothing after it can be reached meanwhile. Suppressed while the form is being
  // built, when the widgets echo back the answers they were handed.
  function invalidate(k) {
    if (state._booting) return;
    if (state.done[k]) state.done[k] = false;
    refreshSteps();
  }

  function sectionHtml(k, n, body) {
    return '<section class="areg-step" id="areg-step-' + k + '" data-step="' + k + '">' +
      '<button type="button" class="areg-step-head" data-step-head="' + k + '" aria-expanded="false" aria-controls="areg-step-body-' + k + '">' +
        '<span class="areg-step-num" data-n="' + n + '">' + n + '</span>' +
        '<span class="areg-step-title">' + esc(stepTitle(k)) + '</span>' +
        '<span class="areg-step-sum" id="areg-sum-' + k + '"></span>' +
        '<span class="areg-step-caret">' + CARET_SVG + '</span>' +
      '</button>' +
      '<div class="areg-step-body" id="areg-step-body-' + k + '"><div class="areg-step-inner">' + body +
        (k === 'confirm' ? '' : '<div class="areg-step-actions"><button type="button" class="areg-btn areg-step-next" data-next="' + k + '" disabled>Continue</button></div>') +
      '</div></div></section>';
  }
  // Step 1 — what kind of sale this is. The words are the server's (lib/bidding-facts,
  // via the shared assets/mhv-bidding-facts.js renderer); nothing here decides them.
  // 'Sunday, October 18, 2026 at 2:00 PM' — the sale's own date and start, as the
  // scheduler wrote them (Eastern wall clock; no timezone maths needed to print them).
  function fmtEventFull() {
    var ev = (state.ctx && state.ctx.event) || {};
    if (!ev.eventDate) return '';
    var p = String(ev.eventDate).split('-'); var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var out = days[d.getUTCDay()] + ', ' + months[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear();
    var t = String(ev.startTime || '').match(/^(\d{1,2}):(\d{2})/);
    if (t) {
      var h = +t[1], ap = h >= 12 ? 'PM' : 'AM';
      out += ' at ' + ((h % 12) || 12) + ':' + t[2] + ' ' + ap;
    }
    return out;
  }
  // Step 1 — the sale (owner, 2026-10-13): its title; the full date and time; the
  // address with the hall on the same line (plain words — no badge in this modal);
  // then what the bidding style means, in a NEUTRAL box, then the loud line. The words
  // of the last two are the server's (lib/bidding-facts via assets/mhv-bidding-facts.js).
  function infoBodyHtml() {
    var ev = (state.ctx && state.ctx.event) || {};
    var f = ev.biddingFacts;
    if (!f || !window.MHVBiddingFacts) return '';
    var halls = { 'upper-hall': 'Upper Hall', 'lower-hall': 'Lower Hall' };
    var where = ev.inPerson ? (ev.address || (ev.location ? locLabel(ev.location) : '')) : '';
    var hall = ev.inPerson && ev.location === 'franklin' ? halls[ev.locationDetail] : '';
    var head = '';
    if (ev.title) head += '<div class="areg-info-title">' + esc(ev.title) + '</div>';
    var when = fmtEventFull();
    // ⏱️ An Online Timed Close sale: the start time IS when lots start closing, one at a
    // time — said in Eastern WITH the zone, as the server's description says it.
    if (when && f.timed) when = 'Lots start closing ' + when + (f.timed.zone ? ' ' + f.timed.zone : '') + ', one at a time';
    if (when) head += '<div class="areg-info-when">' + esc(when) + '</div>';
    if (where) head += '<div class="areg-info-where">' + esc(where) + (hall ? ' · ' + esc(hall) : '') + '</div>';
    return (head ? '<div class="areg-info-head">' + head + '</div>' : '') +
      window.MHVBiddingFacts.styleNote(f) +
      window.MHVBiddingFacts.notice(f);
  }
  function stepBodyHtml(k) {
    if (k === 'info') return infoBodyHtml();
    if (k === 'identity') return bidderBlockHtml();
    if (k === 'rsvp') return rsvpBodyHtml();
    if (k === 'delivery') return '<div id="areg-delivery-choices"></div>';
    if (k === 'card') return cardBodyHtml();
    if (k === 'timing') return timingBodyHtml();
    if (k === 'auth') return '<div class="areg-checks" id="areg-checks"></div>';
    return confirmBodyHtml();
  }

  function renderForm() {
    els.body.style.display = 'block';
    var upd = isUpdating();
    if (els.title) els.title.textContent = upd ? 'Update your registration' : 'Register for this auction';
    var tag = els.card.querySelector('.areg-tagline');
    if (tag) tag.textContent = upd
      ? 'Your choices are below. Open any step to change it, then confirm at the end.'
      : 'A few quick steps, one at a time — each opens when the last is done.';
    state.steps = buildSteps();
    var n = 0;
    els.body.innerHTML = noticeHtml() + flashHtml() + rememberedNoticeHtml() +
      '<div class="areg-steps">' + state.steps.map(function (k) { n++; return sectionHtml(k, n, stepBodyHtml(k)); }).join('') + '</div>';
    wireForm();
    // A registration being CHANGED — or filled in from remembered choices — opens
    // with every step it can already answer finished: on the first one that still
    // needs them (the authorizations are never pre-ticked), or on delivery when the
    // hub sent them here to change it.
    state.done = {};
    if (upd || state.rememberedApplied) state.steps.forEach(function (k) { if (k !== 'confirm' && stepComplete(k)) state.done[k] = true; });
    var want = state.notice ? 'delivery' : null;
    openStep(want && stepReachable(want) ? want : nextStep(), { scroll: false });
  }
  function flashHtml() { return state.flash ? '<div class="areg-callout">' + esc(state.flash) + '</div>' : ''; }
  function rememberKind() { return state.ctx && state.ctx.rememberFormat === 'in_person' ? 'in-person' : 'online-only'; }
  function rememberedNoticeHtml() {
    if (!state.rememberedApplied) return '';
    return '<div class="areg-callout areg-callout--remembered" id="areg-remembered">⭐ You asked us to remember your registration choices for ' + rememberKind() +
      ' auctions, so we’ve filled them in. Check each step, then register.' +
      '<br><button type="button" class="areg-link areg-forget" id="areg-forget">Forget my saved choices</button></div>';
  }
  function forgetRemembered() {
    var btn = q('#areg-forget');
    if (btn) { btn.disabled = true; btn.textContent = 'Forgetting…'; }
    api('/auction-register/remembered', { method: 'DELETE', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ format: state.ctx.rememberFormat }) })
      .then(function (r) {
        if (!r.ok) throw new Error((r.data && r.data.error) || 'Could not forget your saved choices.');
        // Start again from nothing — the context now carries no remembered choices.
        open(Object.assign({}, state.openOpts || {}, { flash: 'Done — your saved choices for ' + rememberKind() + ' auctions are forgotten.' }));
      })
      .catch(function (e) {
        showError(e.message || 'Could not forget your saved choices.');
        if (btn) { btn.disabled = false; btn.textContent = 'Forget my saved choices'; }
      });
  }

  function openStep(k, opts) {
    state.openStep = k;
    state.steps.forEach(function (s) {
      var el = q('#areg-step-' + s); if (!el) return;
      var on = s === k;
      el.classList.toggle('areg-step--open', on);
      var head = el.querySelector('.areg-step-head'); if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    if (k === 'card' && state.cardChoice === 'new') initSquare();
    if (k === 'auth') renderAuth();
    if (k === 'confirm') renderReview();
    refreshSteps();
    var target = k && q('#areg-step-' + k);
    if (target && !(opts && opts.scroll === false)) {
      // After the collapse/expand settles, or we scroll to a stale (taller) layout.
      setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
    }
  }
  function completeStep(k) {
    if (!stepComplete(k)) { refreshSteps(); return; }
    state.done[k] = true;
    openStep(nextStep());
  }
  function refreshSteps() {
    if (!state.steps) return;
    var allDone = true;
    state.steps.forEach(function (k) {
      var el = q('#areg-step-' + k); if (!el) return;
      var done = !!state.done[k];
      if (k !== 'confirm' && !done) allDone = false;
      var reachable = stepReachable(k);
      el.classList.toggle('areg-step--done', done);
      el.classList.toggle('areg-step--locked', !reachable && state.openStep !== k);
      var head = el.querySelector('.areg-step-head');
      if (head) head.disabled = !reachable && state.openStep !== k;
      var num = el.querySelector('.areg-step-num');
      // A finished step is a FILLED circle with its number — no check mark (owner).
      if (num) num.textContent = num.getAttribute('data-n');
      var sum = q('#areg-sum-' + k);
      if (sum) sum.textContent = done ? stepSummary(k) : '';
      var nx = el.querySelector('.areg-step-next');
      if (nx) nx.disabled = !stepComplete(k);
    });
    var sb = q('#areg-submit');
    if (sb && !state.submitting) sb.disabled = !allDone;
  }
  function wireSteps() {
    state.steps.forEach(function (k) {
      var head = q('[data-step-head="' + k + '"]');
      if (head) head.addEventListener('click', function () {
        if (state.openStep === k) { openStep(null); return; }
        if (!stepReachable(k)) return;
        openStep(k, { scroll: false });
      });
      var nx = q('[data-next="' + k + '"]');
      if (nx) nx.addEventListener('click', function () { completeStep(k); });
    });
  }

  // ── Summaries (step headers, the review, the "you're registered" card) ───
  function rsvpLabel(v) { return v === 'yes' ? 'Yes, I’ll be there' : v === 'maybe' ? 'Maybe — bidding online for now' : v === 'no' ? 'No — online only' : ''; }
  function timingSummary() {
    if (state.ctx && state.ctx.isFirstTime) return 'Charged at the end of this auction';
    return state.timing === 'grace_4day' ? '4 days to pay first, then charged'
      : state.timing === 'pay_in_person' ? 'Paying in person by cash or check — card charged after 1 week if not collected'
      : state.timing === 'end_of_auction' ? 'Charged at the end of the auction' : '';
  }
  function cardSummary() {
    var cards = (state.ctx && state.ctx.savedCards) || [];
    if (state.cardChoice === 'new') return 'A new card';
    var k = cards.filter(function (c) { return String(c.id) === String(state.cardChoice); })[0];
    if (k) return (k.brand || 'Card') + ' ending ' + k.last4;
    var ex = state.ctx && state.ctx.existing;
    if (ex && ex.cardLast4) return (ex.cardBrand || 'Card') + ' ending ' + ex.cardLast4;
    return '';
  }
  function slotLabel() {
    var sl = state.pickupSlot;
    if (!sl || sl.auctionDay) return '';
    return (window.MHV && MHV.pickupSlotLabel) ? MHV.pickupSlotLabel(sl) : '';
  }
  function stepSummary(k) {
    if (k === 'info') { var bf = state.ctx && state.ctx.event && state.ctx.event.biddingFacts; return bf && bf.blind ? 'Blind bidding' : 'Read'; }
    if (k === 'identity') return ((CUST.firstName || '') + ' ' + (CUST.lastName || '')).trim() || (state.ctx && state.ctx.bidderNumber ? '#' + state.ctx.bidderNumber : '');
    if (k === 'rsvp') return state.rsvp === 'yes' ? 'Yes' : state.rsvp === 'maybe' ? 'Maybe' : state.rsvp === 'no' ? 'Online only' : '';
    if (k === 'card') return cardSummary();
    if (k === 'timing') return state.timing === 'grace_4day' ? '4 days to pay' : state.timing === 'pay_in_person' ? 'In person' : state.timing ? 'End of auction' : '';
    if (k === 'auth') return 'Agreed';
    if (k === 'delivery') {
      if (state.method === 'auctionday') return 'Auction day';
      if (state.method === 'openbox') return 'Open Box';
      if (state.method === 'shipping') return 'Shipping';
      if (state.method === 'pickup') return 'Pickup' + (state.pickupLocation ? ' · ' + locShort(state.pickupLocation) : '');
    }
    return '';
  }
  // The delivery answer in full — this is the line people were getting wrong, so the
  // review spells out exactly where the winnings are going.
  function deliveryDetailHtml() {
    if (state.method === 'auctionday') {
      return '<b>Collecting at the auction</b><span class="areg-review-sub">' + esc(fmtEventDay()) + ' · ' + esc(locLabel(venueKey())) + '</span>';
    }
    if (state.method === 'shipping') {
      var a = currentShipAddr();
      return '<b>Shipping to me</b>' + (a ? '<span class="areg-review-sub">' + esc((a.firstName + ' ' + a.lastName).trim()) + (a.firstName || a.lastName ? ', ' : '') +
        esc(a.address1) + (a.address2 ? ', ' + esc(a.address2) : '') + ', ' + esc(a.city) + ' ' + esc(a.provinceCode) + ' ' + esc(a.zip) + '</span>' : '');
    }
    if (state.method === 'openbox') return '<b>Open Box</b><span class="areg-review-sub">Held to ship with future wins — no shipping charged now</span>';
    if (state.method === 'pickup') {
      var where = state.pickupLocation ? locLabel(state.pickupLocation) : '';
      var addr = state.pickupLocation ? locAddr(state.pickupLocation) : '';
      var when = slotLabel();
      return '<b>Pickup' + (where ? ' in ' + esc(where) : '') + '</b>' +
        ((addr || when) ? '<span class="areg-review-sub">' + esc([addr, when].filter(Boolean).join(' · ')) + '</span>' : '');
    }
    return '';
  }
  function reviewRowsHtml(withChange) {
    var ev = (state.ctx && state.ctx.event) || {};
    var rows = [];
    if (ev.inPerson && state.rsvp) rows.push(['rsvp', 'Coming in person', esc(rsvpLabel(state.rsvp))]);
    rows.push(['delivery', 'Delivery', deliveryDetailHtml()]);
    rows.push(['card', 'Card on file', esc(cardSummary())]);
    rows.push([state.ctx && state.ctx.isFirstTime ? null : 'timing', 'Payment timing', esc(timingSummary())]);
    return rows.filter(function (r) { return r[2]; }).map(function (r) {
      var change = (withChange && r[0] && state.steps && state.steps.indexOf(r[0]) !== -1)
        ? '<button type="button" class="areg-link-btn areg-review-change" data-goto="' + r[0] + '">Change</button>' : '';
      return '<div class="areg-review-row"><span class="areg-review-label">' + esc(r[1]) + '</span>' +
        '<span class="areg-review-val">' + r[2] + '</span>' + change + '</div>';
    }).join('');
  }
  function renderReview() {
    var box = q('#areg-review'); if (!box) return;
    box.innerHTML = reviewRowsHtml(true);
    box.querySelectorAll('[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () { openStep(b.getAttribute('data-goto')); });
    });
  }

  // ── Step bodies ──────────────────────────────────────────────────────────
  // Locked, read-only bidder identity block (name / bidder # / phone).
  function bidderBlockHtml() {
    var name = ((CUST.firstName || '') + ' ' + (CUST.lastName || '')).trim();
    var sel = currentShipAddr();
    if (!name && sel) name = ((sel.firstName || '') + ' ' + (sel.lastName || '')).trim();
    var phone = CUST.phone || (sel && sel.phone) || '';
    var bidder = state.ctx && state.ctx.bidderNumber;
    var rows = '';
    if (name) rows += identityRow('Name', name);
    if (bidder) rows += identityRow('Bidder #', String(bidder));
    if (phone) rows += identityRow('Phone', formatPhone(phone));
    if (!rows) return '';
    return '<div class="areg-identity">' + rows + '</div>';
  }
  function identityRow(label, value) {
    return '<div class="areg-identity-row"><span class="areg-identity-label">' + esc(label) + '</span><span class="areg-identity-val">' + esc(value) + '</span></div>';
  }

  // Somebody already registered is CHANGING something, and "Register for this
  // auction" on that button reads as "didn't I just do this?".
  function isUpdating() { return !!(state.ctx && state.ctx.existing); }
  function submitLabel() { return isUpdating() ? 'Update my registration' : 'Register for this auction'; }

  function pill(grp, value, icon, label, desc) {
    return '<button type="button" class="areg-pill" data-grp="' + grp + '" data-val="' + escAttr(value) + '"><span class="areg-pill-ico">' + icon + '</span>' +
      '<span class="areg-pill-div" aria-hidden="true"></span>' +
      '<span class="areg-pill-txt"><span class="areg-pill-label">' + esc(label) + '</span>' + (desc ? '<span class="areg-pill-desc">' + esc(desc) + '</span>' : '') + '</span></button>';
  }
  function cardPill(c) { return pill('c', c.id, '💳', (c.brand || 'Card') + ' ending ' + c.last4, 'Expires ' + (c.expMonth || '') + '/' + (c.expYear || '')); }

  function rsvpBodyHtml() {
    var ev = state.ctx && state.ctx.event;
    if (!ev || !ev.inPerson) return '';
    var lbl = ev.location === 'jaffrey' ? 'Jaffrey, NH' : ev.location === 'franklin' ? 'Franklin, NH' : (ev.locationDetail || '');
    var addr = String(ev.address || '');
    // The address usually already names the town — don't print it twice.
    var town = lbl.split(',')[0];
    var where = addr ? (town && addr.toLowerCase().indexOf(town.toLowerCase()) !== -1 ? addr : addr + (lbl ? ', ' + lbl : '')) : lbl;
    var when = fmtEventWhen();
    return '<p class="areg-step-ask">Will you be joining us in person?</p>' +
      (when ? '<div class="areg-rsvp-when">🗓️ ' + esc(when) + '</div>' : '') +
      (where ? '<div class="areg-rsvp-addr">📍 ' + esc(where) + '</div>' : '') +
      '<p class="areg-rsvp-hint">You can change it anytime.</p>' +
      '<div class="areg-list areg-rsvp-list" id="areg-rsvp-list">' +
        pill('rsvp', 'yes', '✅', 'Yes, I’ll be there', '') +
        pill('rsvp', 'maybe', '🤔', 'Maybe, but I’ll just bid online for now', '') +
        pill('rsvp', 'no', '💻', 'No, I’m only going to bid online', '') +
      '</div>' +
      '<div class="areg-callout areg-paddle-note" id="areg-paddle-note" hidden>🎟️ Be sure to check-in and get a paddle when you arrive at the auction hall.</div>';
  }
  // Anyone who might walk in needs to know a paddle is how you bid in the room.
  function paintPaddleNote() {
    var el = q('#areg-paddle-note');
    if (el) el.hidden = !(state.rsvp === 'yes' || state.rsvp === 'maybe');
  }

  function methodPill(m) {
    var ev = (state.ctx && state.ctx.event) || {};
    if (m === 'pickup') {
      var locs = offeredPickupLocs();
      var desc = locs.length === 1 ? ('Pick up in ' + locLabel(locs[0]) + ' only.') : ('Pick up in ' + locs.map(locLabel).join(' or ') + '.');
      return pill('m', 'pickup', '🏠', 'Pickup', desc);
    }
    if (m === 'shipping') return pill('m', 'shipping', '🚚', ev.inPerson ? 'Ship it to me' : 'Shipping', 'We’ll ship your winnings to you.' + shipCaveat());
    return pill('m', 'openbox', '📦', 'Open Box (Hold Shipping)', 'Hold shipping & combine with future wins — pay shipping once.');
  }
  function methodSubHtml(m) {
    if (m === 'shipping') return '<div id="areg-ship"></div>';
    if (m === 'openbox') return openBoxSectionHtml();
    return pickupSectionHtml();
  }
  function deliveryChoicesHtml() {
    if (yesMode()) {
      // Coming in person: two answers, and neither is assumed.
      return '<p class="areg-step-ask">How would you like to collect your winnings?</p>' +
        '<div class="areg-list areg-method-list" id="areg-method-list">' +
          pill('m', 'auctionday', '🏛️', 'I’ll pick up on auction day', fmtEventDay() + ' · ' + locLabel(venueKey())) +
          '<div class="areg-sub" id="areg-sub-auctionday" hidden><p class="areg-muted areg-sub-say">You’ll pay and collect your winnings at the checkout desk after the sale. If your plans change, you can switch to a later pickup anytime.</p></div>' +
          pill('m', 'pickup', '🏠', 'I’ll pick up at a later date', 'Choose a pickup day — or we’ll reach out to schedule.') +
          '<div class="areg-sub" id="areg-sub-pickup" hidden>' + pickupSectionHtml() + '</div>' +
        '</div>';
    }
    var methods = methodOptions();
    var locs = offeredPickupLocs();
    var inPerson = !!((state.ctx && state.ctx.event) || {}).inPerson;
    // Pickup only, one place: nothing to choose. Say where, and (at an in-person
    // sale) keep the pickup time folded behind an optional link — across three
    // in-person sales 103 of 127 registrants set no time.
    if (methods.length === 1 && locs.length === 1) {
      var lk = locs[0], addr = locAddr(lk);
      var note = '<div class="areg-callout areg-callout--only">📍 <b>Pickup only</b> — ' + esc(locLabel(lk)) + (addr ? ', ' + esc(addr) : '') +
        (inPerson ? '. We’ll have your winnings ready after the sale.' : '. No shipping for this auction.') + '</div>';
      var body = inPerson
        ? '<div id="areg-pickup-list" style="display:none;"></div>' +
          '<p class="areg-note areg-note--transfer" id="areg-transfer-note" style="display:none;"></p>' +
          '<button type="button" class="areg-link" id="areg-choose-time">📅 Choose a pickup time (optional)</button>' +
          '<div id="areg-pickup-slots" style="display:none;"><h4 class="areg-subhead">Pick a day &amp; time</h4><div id="areg-pickup-slots-inner"></div></div>'
        : pickupSectionHtml();
      return note + '<div class="areg-sub areg-sub--bare" id="areg-sub-pickup" data-always="1">' + body + '</div>';
    }
    var html = shippingOffered() ? '' : '<p class="areg-note">📍 This auction is <b>pickup only</b> — shipping isn’t offered.</p>';
    html += '<p class="areg-step-ask">How would you like to get your winnings?</p><div class="areg-list areg-method-list" id="areg-method-list">';
    methods.forEach(function (m) { html += methodPill(m) + '<div class="areg-sub" id="areg-sub-' + m + '" hidden>' + methodSubHtml(m) + '</div>'; });
    return html + '</div>';
  }
  // The choices are rebuilt only when the KIND of question changes (coming in
  // person vs not) — they share element ids, so only one set may exist at a time.
  function renderDeliveryChoices() {
    var box = q('#areg-delivery-choices'); if (!box) return false;
    var mode = yesMode() ? 'yes' : 'std';
    if (box.getAttribute('data-mode') === mode) return false;
    box.setAttribute('data-mode', mode);
    box.innerHTML = deliveryChoicesHtml();
    qa('#areg-method-list > .areg-pill').forEach(function (c) { c.addEventListener('click', function () { selectMethod(c.getAttribute('data-val')); }); });
    qa('#areg-pickup-list .areg-pill').forEach(function (c) { c.addEventListener('click', function () { selectPickup(c.getAttribute('data-val')); }); });
    var chooseTime = q('#areg-choose-time');
    if (chooseTime) chooseTime.addEventListener('click', function () { state._timeOpen = true; renderPickupSlots(); });
    renderShip();
    return true;
  }
  function deliveryBodyHtml() { return '<div id="areg-delivery-choices"></div>'; }

  function cardBodyHtml() {
    var cards = state.ctx.savedCards || [];
    var note = state.forcedAutoCharge ? '' : '<p class="areg-note">This is the card we’ll charge if you don’t pay another way — you can still use a different card when you check out.</p>';
    return (cards.length ? '<p class="areg-step-ask">Which card should we keep on file for this auction?</p><div class="areg-list" id="areg-card-list">' + cards.map(cardPill).join('') + pill('c', 'new', '➕', 'Use a different card', 'Enter a new card below') + '</div>' : '') +
      '<div id="areg-new-card" style="' + (cards.length ? 'display:none;' : '') + 'margin-top:10px;">' +
        '<div id="areg-sq-card" class="areg-sq-card"></div>' +
        '<div class="areg-sq-trust" id="areg-card-hint">' + sqTrustHtml() + '</div>' +
      '</div>' + note;
  }
  function timingBodyHtml() {
    return '<p class="areg-step-ask">How would you like to pay for your winnings?</p>' +
      '<div class="areg-callout areg-first-time" id="areg-first-time-note" hidden>' +
        'Because this is your first purchase with us, your card is charged when the auction ends. ' +
        'Once you’ve completed an order, the other options open up. ' +
        'Would you like to make another arrangement? Call or text us at <a href="tel:+16034516960">(603) 451-6960</a>.' +
      '</div>' +
      '<div class="areg-list" id="areg-timing-list"></div>';
  }
  // Paying by cash or check means being there to hand it over, so it is offered
  // only to somebody collecting (on auction day or later) — and dropped, not left
  // selected, if they switch to shipping or Open Box.
  var TIMING_DEFS = {
    pay_in_person: ['💵', 'I’ll pay in person by cash or check', 'Pay when you collect your winnings. If you haven’t picked up within 1 week of the auction, we’ll charge your card for the balance.'],
    end_of_auction: ['⚡', 'Charge my card when the auction ends', 'We charge the card on file for your winnings as soon as your invoice is ready.'],
    grace_4day: ['🗓️', 'Give me 4 days to pay first', 'Pay your invoice any way you like within 4 days; anything still unpaid is then charged to your card.']
  };
  // Charge-at-end leads; paying in person is LAST and offered to pickup only.
  function timingOptions() {
    var o = ['end_of_auction', 'grace_4day'];
    if (state.fulfillment === 'pickup') o.push('pay_in_person');
    return o;
  }
  function renderTiming() {
    var list = q('#areg-timing-list'); if (!list) return;
    if (state.timing === 'pay_in_person' && state.fulfillment !== 'pickup') { state.timing = null; invalidate('timing'); }
    // ⚠️ A FIRST-TIME BUYER sees every option but may only take the first: a first
    // purchase is charged when the auction ends (Bidder Terms). The server forces it
    // regardless — the locked pills say so rather than hiding choices they will
    // have next time.
    var first = !!(state.ctx && state.ctx.isFirstTime);
    var opts = timingOptions(), key = opts.join(',') + (first ? ':first' : '');
    if (list.getAttribute('data-opts') !== key) {
      list.setAttribute('data-opts', key);
      list.innerHTML = opts.map(function (k) { return pill('t', k, TIMING_DEFS[k][0], TIMING_DEFS[k][1], TIMING_DEFS[k][2]); }).join('');
      list.querySelectorAll('.areg-pill').forEach(function (c) {
        if (first && c.getAttribute('data-val') !== 'end_of_auction') { c.disabled = true; c.classList.add('areg-pill--locked'); return; }
        c.addEventListener('click', function () { selectTiming(c.getAttribute('data-val')); });
      });
    }
    var fn = q('#areg-first-time-note'); if (fn) fn.hidden = !first;
    selectGroup('t', state.timing);
  }
  function confirmBodyHtml() {
    var remember = state.ctx.rememberFormat
      ? '<label class="areg-check areg-remember"><input type="checkbox" id="areg-remember"' + (state.ctx.remembered ? ' checked' : '') + '>' +
          '<span><b>Remember my registration choices for future ' + rememberKind() + ' auctions</b>' +
          '<span class="areg-remember-sub">Next time, we’ll fill these answers in for you to make registration quick and easy.</span></span></label>'
      : '';
    return '<div class="areg-review" id="areg-review"></div>' + remember +
      '<p class="areg-summary">By ' + (isUpdating() ? 'updating' : 'registering') + ', you’re authorizing us to charge the card on file for your winnings from this auction.</p>' +
      '<button type="button" class="areg-btn" id="areg-submit" disabled>' + esc(submitLabel()) + '</button>';
  }
  var TERMS_CHECK_HTML = 'I have read and agree to the <a href="/pages/bidder-terms" target="_blank" rel="noopener">Bidder Terms &amp; Conditions</a>, including the phone verification, card-on-file, and automatic-charge terms.';
  // Rebuilt whenever the answers it describes change. A box stays ticked only if
  // the words beside it are the words they ticked — a changed authorization is a
  // different authorization, and has to be agreed to again.
  function renderAuth() {
    var box = q('#areg-checks'); if (!box) return;
    var prev = {};
    box.querySelectorAll('input[data-consent]').forEach(function (i) { prev[i.getAttribute('data-consent')] = { checked: i.checked, text: i.parentNode.textContent }; });
    var items = [['cardAuth', esc(cardAuthText())], ['timing', esc(timingConsentText()), 'areg-check-timing'], ['cardLock', esc(cardLockText())], ['terms', TERMS_CHECK_HTML]];
    box.innerHTML = items.map(function (it) { return check(it[0], it[1], it[2]); }).join('');
    var lost = false;
    box.querySelectorAll('input[data-consent]').forEach(function (i) {
      var p = prev[i.getAttribute('data-consent')];
      if (p && p.checked) { if (p.text === i.parentNode.textContent) i.checked = true; else lost = true; }
    });
    if (lost) invalidate('auth'); else refreshSteps();
  }

  // Trust line — mirrors checkout's sqTrustHtml (lock + Square logo + reassurance).
  function sqTrustHtml() {
    var logo = (state.sqcfg && state.sqcfg.squareLogoUrl) || SQUARE_LOGO;
    return '🔒 Encrypted &amp; stored by <img class="areg-sq-logo" src="' + escAttr(logo) + '" alt="Square"> — your full card number never reaches Granite Union Auction Company.';
  }

  // ---- Pickup sub-options (location + optional day/time) ------------------
  function pickupSectionHtml() {
    var keys = offeredPickupLocs();
    // Each location's own caveat: at a Franklin sale with a handful of
    // Jaffrey-collectable lots, "Jaffrey, NH — 6 of 180 lots" is the whole story,
    // and the alternative is a bidder choosing Jaffrey for a sale that is at Franklin.
    var cards = PICKUP_LOCATIONS.filter(function (l) { return keys.indexOf(l[0]) !== -1; });
    var pills = cards.map(function (l) {
      return pill('p', l[0], '🏠', l[1], l[2] + pickupCaveat(l[0].replace('_nh', '')));
    }).join('');
    var onsiteNote = (keys.length === 1 && keys[0] === 'onsite')
      ? '<p class="areg-note">Onsite pickup — we’ll arrange it with you.</p>' : '';
    var changeNote = (state.forcedAutoCharge || cards.length <= 1) ? '' : '<p class="areg-note">You can change your pickup location at checkout.</p>';
    // With a single location there's nothing to choose — skip the "where" heading.
    var heading = cards.length > 1 ? '<h4 class="areg-subhead">Where would you like to pick up?</h4>' : '';
    return heading +
      '<div class="areg-list" id="areg-pickup-list">' + pills + '</div>' +
      '<p class="areg-note areg-note--transfer" id="areg-transfer-note" style="display:none;"></p>' + onsiteNote + changeNote +
      '<div id="areg-pickup-slots" style="display:none;"><h4 class="areg-subhead">Pick a day &amp; time <span class="areg-optional">(optional)</span></h4><div id="areg-pickup-slots-inner"></div></div>';
  }
  // Why a location can show no days: the server drops pickup days whose transfer van has
  // already left (lib/pickup-transport). Saying "no set times" there would be untrue.
  function pickupEmptyNote() {
    var ev = state.ctx && state.ctx.event;
    var merch = ev && ev.merchLocation ? String(ev.merchLocation) : '';
    var here = String(state.pickupLocation || '').replace(/_nh$/, '');
    if (!merch || !here || merch === here) return '';
    return 'No more ' + (here.charAt(0).toUpperCase() + here.slice(1)) + ' pickup times are ' +
      'available for this weekend — lots travel from ' + (merch.charAt(0).toUpperCase() + merch.slice(1)) +
      ' on Friday morning and that van has gone. Pick another location or a later date, or ' +
      'call or text <a href="tel:+16034516960">(603) 451-6960</a> and we’ll arrange a time.';
  }

  // Render the shared pickup-day/time picker for the chosen location.
  function renderPickupSlots() {
    var wrap = q('#areg-pickup-slots');
    var inner = q('#areg-pickup-slots-inner');
    if (!wrap || !inner) return;
    if (state.fulfillment !== 'pickup' || state.method === 'auctionday' || !state.pickupLocation || state.pickupLocation === 'onsite' || !window.MHV || !MHV.renderPickupSlots) {
      wrap.style.display = 'none'; return;
    }
    // Folded behind "Choose a pickup time (optional)" until tapped (in-person, pickup-only).
    if (q('#areg-choose-time') && !state._timeOpen && !(state.pickupSlot && !state.pickupSlot.auctionDay)) { wrap.style.display = 'none'; return; }
    var ct = q('#areg-choose-time'); if (ct) ct.style.display = 'none';
    wrap.style.display = '';
    MHV.renderPickupSlots(inner, {
      pickupDays: (state.ctx && state.ctx.pickupDays) || [],
      location: state.pickupLocation,
      selected: state.pickupSlot,
      catchAllLabel: "I'll reach out to schedule",
      emptyNote: pickupEmptyNote(),
      changeNote: !state.forcedAutoCharge,
      onChange: function (slot) {
        var changed = JSON.stringify(slot || null) !== JSON.stringify(state.pickupSlot || null);
        state.pickupSlot = slot;
        if (changed) invalidate('delivery');
      }
    });
  }

  // ---- Shipping sub-options (active address + saved-address picker + add/edit)
  function addrLineHtml(a) {
    var l2 = a.address2 ? ', ' + esc(a.address2) : '';
    return '<div class="areg-addr-name">' + (esc((a.firstName + ' ' + a.lastName).trim()) || 'Address') + '</div>' +
      '<div class="areg-addr-lines">' + esc(a.address1) + l2 + ', ' + esc(a.city) + ' ' + esc(a.provinceCode) + ' ' + esc(a.zip) + '</div>';
  }
  function activeAddrCardHtml(a) {
    var badge = a.isDefault ? '<span class="areg-addr-default">Default</span>'
      : (a._onRecord ? '<span class="areg-addr-default">On your registration</span>'
      : a._remembered ? '<span class="areg-addr-default">Your saved choice</span>'
      : (a._oneOff ? '<span class="areg-addr-default areg-addr-oneoff">This order only</span>' : ''));
    return '<div class="areg-address-card areg-address-active sel">' +
      '<div class="areg-addr-text">' + addrLineHtml(a) + '</div>' +
      '<div class="areg-addr-side"><span class="areg-addr-check">✓ Shipping here</span>' + badge + '</div>' +
    '</div>';
  }
  // Open Box option section — how it works + a notice if they ALREADY have an open box.
  function openBoxSectionHtml() {
    var ob = state.ctx && state.ctx.openBox;
    var existing = ob
      ? '<p class="areg-note areg-note-ok">📦 You already have an open box (' + ob.count + ' held order' + (ob.count === 1 ? '' : 's') + '). This auction’s winnings will be <strong>added to it</strong>.</p>'
      : '';
    return '<div class="areg-openbox-info">' +
      '<p class="areg-muted"><strong>How Open Box works:</strong> we hold your won items and combine them with future wins so you pay shipping <strong>once</strong>. Your box stays open until you choose shipping on a future order or close it from your account page. Pickup orders can’t go in an open box.</p>' +
      existing + '</div>';
  }
  // Shown on the SHIPPING option when the buyer already has an open box — shipping closes it.
  function openBoxShipDisclosure() {
    var ob = state.ctx && state.ctx.openBox;
    if (!ob) return '';
    return '<p class="areg-note areg-note-warn">📦 You have an open box (' + ob.count + ' held order' + (ob.count === 1 ? '' : 's') + '). Choosing <strong>Shipping</strong> will close it and <strong>all held items ship together</strong> with this auction’s winnings.</p>';
  }
  function shipSectionHtml() {
    var sel = currentShipAddr();
    var html = '<p class="areg-muted">Where should we ship your winnings?' + (state.forcedAutoCharge ? '' : ' You can still change it at checkout.') + '</p>';
    if (sel) {
      html += '<div class="areg-address-list">' + activeAddrCardHtml(sel) + '</div>';
      html += '<div class="areg-addr-actions">';
      if (state.addresses.length > 1) html += '<button type="button" class="areg-link-btn" id="areg-addr-view">Choose another of your ' + state.addresses.length + ' saved addresses</button>';
      html += '<button type="button" class="areg-link-btn" id="areg-addr-add">+ Add a new address</button></div>';
    } else {
      html += '<p class="areg-muted">No address yet — add one to ship your winnings.</p>' +
        '<div class="areg-addr-actions"><button type="button" class="areg-btn areg-btn-secondary" id="areg-addr-add">+ Add an address</button></div>';
    }
    html += openBoxShipDisclosure();
    return html;
  }
  function renderShip() {
    var el = q('#areg-ship'); if (!el) return;
    el.innerHTML = shipSectionHtml();
    var v = el.querySelector('#areg-addr-view'); if (v) v.addEventListener('click', function () { openAddrModal('pick'); });
    var a = el.querySelector('#areg-addr-add'); if (a) a.addEventListener('click', function () { openAddrModal('pick'); renderAddrForm(null); });
    // A different address is a different answer — confirm it again.
    if (state.method === 'shipping') invalidate('delivery');
  }

  function rowF(inner) { return '<div class="areg-row">' + inner + '</div>'; }
  function fieldF(label, id, value) { return '<label class="areg-fl"><span>' + esc(label) + '</span><input type="text" id="' + id + '" class="areg-in" value="' + escAttr(value || '') + '"></label>'; }
  function stateOptsHtml(sel) { return '<option value="">State</option>' + STATES.map(function (s) { return '<option value="' + s + '"' + (s === (sel || '') ? ' selected' : '') + '>' + s + '</option>'; }).join(''); }
  function check(key, html, id) { return '<label class="areg-check"' + (id ? ' id="' + id + '"' : '') + '><input type="checkbox" data-consent="' + key + '"><span>' + html + '</span></label>'; }

  function wireForm() {
    state._booting = true;
    qa('#areg-rsvp-list .areg-pill').forEach(function (c) { c.addEventListener('click', function () { selectRsvp(c.getAttribute('data-val')); }); });
    qa('#areg-card-list .areg-pill').forEach(function (c) { c.addEventListener('click', function () { selectCard(c.getAttribute('data-val')); }); });
    // Reflect the answers we already have — theirs, or the only option there is.
    selectGroup('rsvp', state.rsvp);
    paintPaddleNote();
    applyRsvpToDelivery();          // builds the delivery choices + reflects the method
    renderTiming();
    selectGroup('c', state.cardChoice);
    var nc = q('#areg-new-card'); if (nc && (state.ctx.savedCards || []).length) nc.style.display = state.cardChoice === 'new' ? 'block' : 'none';
    renderAuth();
    var checks = q('#areg-checks');
    if (checks) checks.addEventListener('change', function () { if (state.done.auth && !authComplete()) invalidate('auth'); else refreshSteps(); });
    q('#areg-submit').addEventListener('click', function () { submit(); });
    var fg = q('#areg-forget'); if (fg) fg.addEventListener('click', forgetRemembered);
    wireSteps();
    state._booting = false;
  }

  // Nothing chosen → nothing lit and nothing dimmed. (Dimming every option before a
  // choice reads as "these are unavailable".)
  function selectGroup(grp, value) {
    qa('.areg-pill[data-grp="' + grp + '"]').forEach(function (c) {
      var on = value != null && c.getAttribute('data-val') === String(value);
      c.classList.toggle('sel', on);
      c.classList.toggle('dim', value != null && !on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  // Re-trigger the slide-down on a sub-options panel each time it shows.
  function reveal(el) { if (!el) return; el.style.animation = 'none'; void el.offsetWidth; el.style.animation = ''; }

  function selectRsvp(v) {
    if (state.rsvp === v) return;
    state.rsvp = v; state.rsvpTouched = true;
    selectGroup('rsvp', v);
    paintPaddleNote();
    invalidate('rsvp');
    applyRsvpToDelivery();
  }
  // In-person: "Yes, I'll be there" REPLACES the delivery choices with the collect-at-
  // the-desk line and books the auction-day slot. Anything else shows the choices —
  // EMPTY, not defaulted: "I'm not coming" is not an answer to "how do we get it to you".
  // The RSVP decides which delivery question is asked. Switching between "coming"
  // and "not coming" drops an answer the new question does not offer — it is
  // EMPTIED, never swapped for a default — and re-opens the delivery step.
  function applyRsvpToDelivery() {
    if (state.method && methodOptions().indexOf(state.method) === -1) {
      if (state.method === 'auctionday') state.pickupLocation = null;
      if (state.pickupSlot && state.pickupSlot.auctionDay) state.pickupSlot = null;
      state.method = null; state.fulfillment = null;
    }
    var rebuilt = renderDeliveryChoices();
    applySingleOptions();
    selectMethod(state.method);
    if (rebuilt) invalidate('delivery');
  }
  function selectMethod(m) {
    var changed = state.method !== m;
    // Auction day put the VENUE in pickupLocation; that is not an answer to "which
    // building for a later pickup", so leaving auction day leaves it unanswered.
    if (state.method === 'auctionday' && m !== 'auctionday') state.pickupLocation = null;
    state.method = m || null;
    selectGroup('m', state.method);
    var auctionDay = m === 'auctionday';
    // Auction day IS a pickup — at the sale's venue, on the sale's date — so the
    // server-side shape is unchanged; only the choice is different.
    state.fulfillment = !m ? null : auctionDay ? 'pickup' : m;
    if (auctionDay) { state.pickupLocation = venueKey(); state.pickupSlot = auctionDaySlot(); }
    else if (state.pickupSlot && state.pickupSlot.auctionDay) { state.pickupSlot = null; }
    if (m === 'pickup' && !state.pickupLocation) { var locs = offeredPickupLocs(); if (locs.length === 1) state.pickupLocation = locs[0]; }
    // Each option's details open directly BELOW its own button (the checkout's model).
    ['auctionday', 'pickup', 'shipping', 'openbox'].forEach(function (x) {
      var sub = q('#areg-sub-' + x); if (!sub) return;
      var show = sub.getAttribute('data-always') === '1' || x === m;
      sub.hidden = !show;
      if (show && changed && x === m) reveal(sub);
    });
    if (state.fulfillment === 'pickup' && !auctionDay) { selectGroup('p', state.pickupLocation); renderTransferNote(); }
    renderPickupSlots();
    renderTiming();
    renderAuth();
    if (changed) invalidate('delivery'); else refreshSteps();
  }
  function selectPickup(p) {
    if (state.pickupLocation === p) return;
    state.pickupSlot = null; // slot is location-specific
    state.pickupLocation = p; selectGroup('p', p);
    renderTransferNote();
    renderPickupSlots();
    invalidate('delivery');
  }

  // ⚠️ COLLECTING WHERE THE GOODS ARE NOT IS A PROMISE SOMEBODY DRIVES THEM THERE.
  // Say so at the moment it is chosen, not at the moment they turn up: the lots
  // travel on the weekly run, so "same day" is never the answer for the other
  // building. (The staff side of this is the transfer flag the invoice raises.)
  function renderTransferNote() {
    var el = q('#areg-transfer-note');
    if (!el) return;
    var ev = (state.ctx && state.ctx.event) || {};
    var merch = String(ev.merchLocation || '').toLowerCase();
    var here = String(state.pickupLocation || '').replace(/_nh$/, '').toLowerCase();
    if (!merch || !here || here === 'onsite' || merch === here) { el.style.display = 'none'; el.textContent = ''; return; }
    var cap = function (v) { return v.charAt(0).toUpperCase() + v.slice(1); };
    el.textContent = '🚚 These lots are at ' + cap(merch) + '. We’ll bring them to ' + cap(here) +
      ' on our next run — we’ll let you know when they’re ready.';
    el.style.display = '';
  }
  function selectTiming(t) {
    if (state.timing === t) return;
    state.timing = t; selectGroup('t', t);
    invalidate('timing');
    renderAuth();
  }
  function selectCard(value) {
    value = String(value);
    if (state.cardChoice === value) return;
    state.cardChoice = value; selectGroup('c', value);
    var isNew = value === 'new';
    var nc = q('#areg-new-card'); if (nc) nc.style.display = isNew ? 'block' : 'none';
    if (isNew) initSquare();
    invalidate('card');
  }

  function initSquare() {
    if (state.sq.ready || state.sq.loading) return;
    var appId = state.sqcfg.squareAppId, locId = state.sqcfg.squareLocationId;
    if (!appId || !locId) { var h = q('#areg-card-hint'); if (h) h.textContent = 'Card processing is unavailable right now.'; return; }
    state.sq.loading = true;
    var sdk = state.sqcfg.squareEnv === 'sandbox' ? 'https://sandbox.web.squarecdn.com/v1/square.js' : 'https://web.squarecdn.com/v1/square.js';
    loadScript(sdk).then(function () { return window.Square.payments(appId, locId); })
      .then(function (payments) { state.sq.payments = payments; return payments.card(); })
      .then(function (card) { return card.attach('#areg-sq-card').then(function () { state.sq.card = card; state.sq.ready = true; state.sq.loading = false; refreshSteps(); }); })
      .catch(function () { state.sq.loading = false; var h = q('#areg-card-hint'); if (h) h.textContent = 'We couldn’t load the card form. Please try again.'; });
  }

  // ---------------------------------------------------------------------------
  // Address modal (nested) — reuses the account address endpoints, mirrors checkout.
  // ---------------------------------------------------------------------------
  function ensureAddrModal() {
    if (byId('areg-addr-modal')) return;
    var ov = document.createElement('div'); ov.className = 'areg-modal-overlay'; ov.id = 'areg-addr-modal';
    ov.innerHTML = '<div class="areg-modal"><h3 id="areg-modal-title">Address</h3>' +
      '<div id="areg-modal-fields"></div>' +
      '<div class="areg-modal-actions"><button type="button" class="areg-btn areg-btn-secondary" id="areg-modal-cancel">Cancel</button>' +
      '<button type="button" class="areg-btn" id="areg-modal-save">Save</button></div></div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) { if (e.target === ov) closeAddrModal(); });
    byId('areg-modal-cancel').addEventListener('click', closeAddrModal);
  }
  function openAddrModal(mode) { ensureAddrModal(); state._addrMode = mode || 'pick'; renderAddrManager(); byId('areg-addr-modal').classList.add('areg-show'); }
  function closeAddrModal() { var m = byId('areg-addr-modal'); if (m) m.classList.remove('areg-show'); }

  function renderAddrManager() {
    var pick = state._addrMode === 'pick';
    byId('areg-modal-title').textContent = pick ? 'Choose a shipping address' : 'Your addresses';
    var list = state.addresses.map(function (a) {
      var def = a.isDefault ? ' <span class="areg-addr-default">Default</span>' : '';
      var shipBtn = pick ? '<button type="button" class="areg-btn areg-btn-sm" data-ship="' + escAttr(a.id) + '">Ship here</button>' : '';
      return '<div class="areg-address-card areg-address-managed">' +
        '<div class="areg-addr-text"><div class="areg-addr-name">' + esc((a.firstName + ' ' + a.lastName).trim()) + def + '</div>' +
        '<div class="areg-addr-lines">' + esc(a.address1) + ', ' + esc(a.city) + ' ' + esc(a.provinceCode) + ' ' + esc(a.zip) + '</div></div>' +
        '<div class="areg-addr-manage-row">' + shipBtn +
          '<a class="areg-link-btn" data-edit="' + escAttr(a.id) + '">Edit</a>' +
          (a.isDefault ? '' : '<a class="areg-link-btn" data-default="' + escAttr(a.id) + '">Set default</a>') +
          '<a class="areg-link-btn areg-link-danger" data-del="' + escAttr(a.id) + '">Delete</a>' +
        '</div></div>';
    }).join('');
    var mf = byId('areg-modal-fields');
    mf.innerHTML = (list || '<p class="areg-muted">No addresses yet.</p>') +
      '<div style="margin-top:14px;"><button type="button" class="areg-btn areg-btn-secondary" id="areg-addr-new">+ Add new address</button></div>';
    byId('areg-modal-save').style.display = 'none';
    mf.querySelectorAll('[data-ship]').forEach(function (b) { b.addEventListener('click', function () { chooseSaved(b.getAttribute('data-ship')); }); });
    mf.querySelectorAll('[data-edit]').forEach(function (b) { b.addEventListener('click', function () { renderAddrForm(b.getAttribute('data-edit')); }); });
    mf.querySelectorAll('[data-default]').forEach(function (b) { b.addEventListener('click', function () { setDefaultAddr(b.getAttribute('data-default')); }); });
    mf.querySelectorAll('[data-del]').forEach(function (b) { b.addEventListener('click', function () { if (window.confirm('Delete this address?')) deleteAddr(b.getAttribute('data-del')); }); });
    byId('areg-addr-new').addEventListener('click', function () { renderAddrForm(null); });
  }

  function chooseSaved(id) { state.oneOffAddress = null; state.shippingAddressId = String(id); closeAddrModal(); renderShip(); }

  function renderAddrForm(id) {
    var a = state.addresses.filter(function (x) { return x.id === id; })[0] || {};
    byId('areg-modal-title').textContent = id ? 'Edit address' : 'Add address';
    byId('areg-modal-fields').innerHTML =
      rowF(fieldF('First name', 'af-first', a.firstName) + fieldF('Last name', 'af-last', a.lastName)) +
      fieldF('Address', 'af-addr1', a.address1) +
      fieldF('Apt / Suite (optional)', 'af-addr2', a.address2) +
      rowF(fieldF('City', 'af-city', a.city) + '<label class="areg-fl"><span>State</span><select id="af-prov" class="areg-in">' + stateOptsHtml(a.provinceCode) + '</select></label>') +
      rowF(fieldF('ZIP', 'af-zip', a.zip) + fieldF('Phone (optional)', 'af-phone', a.phone)) +
      (id ? '' : '<label class="areg-check areg-save-row"><input type="checkbox" id="af-save" checked><span>Save this address to my account</span></label>') +
      '<label class="areg-check"><input type="checkbox" id="af-default"' + (a.isDefault ? ' checked' : '') + '><span>Make this my default</span></label>';
    var saveBtn = byId('areg-modal-save');
    saveBtn.style.display = ''; saveBtn.textContent = 'Use this address';
    saveBtn.onclick = function () { submitAddr(id); };
    attachPlaces('af-addr1', { address1: 'af-addr1', city: 'af-city', state: 'af-prov', zip: 'af-zip' });
  }

  function submitAddr(id) {
    var addr = { first_name: val('af-first'), last_name: val('af-last'), address1: val('af-addr1'),
      address2: val('af-addr2'), city: val('af-city'), province_code: val('af-prov').toUpperCase(),
      zip: val('af-zip'), phone: val('af-phone'), country: 'United States', country_code: 'US' };
    if (!addr.address1 || !addr.city || !addr.province_code || !addr.zip) { window.alert('Please fill address, city, state and ZIP.'); return; }

    // New address + "Save" unchecked → use it for THIS registration only (no Shopify save).
    var saveIt = id ? true : !(byId('af-save') && !byId('af-save').checked);
    if (!saveIt) {
      state.oneOffAddress = { _oneOff: true, id: null, isDefault: false, firstName: addr.first_name, lastName: addr.last_name,
        address1: addr.address1, address2: addr.address2, city: addr.city, provinceCode: addr.province_code, zip: addr.zip, phone: addr.phone, country: 'US' };
      state.shippingAddressId = null; closeAddrModal(); renderShip(); return;
    }
    if (!CUST.email) { window.alert('Please sign in to save addresses.'); return; }

    var makeDefault = byId('af-default') && byId('af-default').checked;
    var path = id ? 'update-address' : 'add-address';
    var verb = id ? 'PUT' : 'POST';
    var body = { customer_email: CUST.email, address: addr };
    if (id) body.address_id = id;
    var saveBtn = byId('areg-modal-save'); saveBtn.disabled = true;
    api('/' + path, { method: verb, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (resp) {
        saveBtn.disabled = false;
        if (!resp.ok || !resp.data || !resp.data.success) { window.alert((resp.data && resp.data.error) || 'Could not save address.'); return; }
        var saved = normShopifyAddr(resp.data.address || {});
        if (!saved.id && id) saved.id = String(id);
        var idx = -1;
        for (var i = 0; i < state.addresses.length; i++) { if (state.addresses[i].id === saved.id) { idx = i; break; } }
        if (idx >= 0) state.addresses[idx] = saved; else state.addresses.push(saved);
        function finish() { state.oneOffAddress = null; state.shippingAddressId = saved.id; closeAddrModal(); renderShip(); }
        if (makeDefault && saved.id) {
          api('/set-default-address', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customer_email: CUST.email, address_id: saved.id }) })
            .then(function () { applyDefault(saved.id); }).catch(function () {}).then(finish);
        } else { finish(); }
      })
      .catch(function () { saveBtn.disabled = false; window.alert('Network error.'); });
  }

  function setDefaultAddr(id) {
    api('/set-default-address', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customer_email: CUST.email, address_id: id }) })
      .then(function (resp) {
        if (!resp.ok) { window.alert((resp.data && resp.data.error) || 'Could not set default.'); return; }
        applyDefault(id); renderAddrManager(); renderShip();
      })
      .catch(function () { window.alert('Network error.'); });
  }
  function deleteAddr(id) {
    id = String(id);
    api('/delete-address', { method: 'DELETE', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customer_email: CUST.email, address_id: id }) })
      .then(function (resp) {
        if (!resp.ok) { window.alert((resp.data && resp.data.error) || 'Could not delete.'); return; }
        state.addresses = state.addresses.filter(function (a) { return a.id !== id; });
        if (state.shippingAddressId === id) {
          state.shippingAddressId = null;
          var d = state.addresses.filter(function (a) { return a.isDefault; })[0] || state.addresses[0];
          if (d) state.shippingAddressId = d.id;
        }
        renderAddrManager(); renderShip();
      })
      .catch(function () { window.alert('Network error.'); });
  }

  // Google Places address autocomplete — SAME loader/key/new-API as checkout
  // (bootstrap injected in theme.liquid). Manual typing always works.
  function attachPlaces(addr1Id, fields) {
    var input = byId(addr1Id);
    if (!input || input._acWired) return;
    if (!(window.google && window.google.maps && window.google.maps.importLibrary)) return;
    input._acWired = true;
    input.setAttribute('autocomplete', 'off');
    var list = document.createElement('ul');
    list.className = 'areg-ac-list';
    if (input.parentNode) { input.parentNode.style.position = 'relative'; input.parentNode.appendChild(list); }

    function ftext(ft) { return !ft ? '' : (typeof ft === 'string' ? ft : (ft.text || '')); }
    function comp(components, type) { for (var i = 0; i < components.length; i++) { if (components[i].types && components[i].types.indexOf(type) !== -1) return components[i]; } return null; }

    window.google.maps.importLibrary('places').then(function (lib) {
      var AutocompleteSuggestion = lib.AutocompleteSuggestion, AutocompleteSessionToken = lib.AutocompleteSessionToken;
      if (!AutocompleteSuggestion || !AutocompleteSessionToken) return;
      var token = new AutocompleteSessionToken();
      var preds = [], activeIdx = -1, debounce = null;

      function closeList() { list.classList.remove('open'); list.innerHTML = ''; activeIdx = -1; }
      function render() {
        if (!preds.length) { closeList(); return; }
        list.innerHTML = preds.map(function (p, i) {
          var main = ftext(p.mainText) || ftext(p.text), sub = ftext(p.secondaryText);
          return '<li class="areg-ac-opt" data-i="' + i + '"><span class="areg-ac-main">' + esc(main) + '</span>' + (sub ? '<span class="areg-ac-sub">' + esc(sub) + '</span>' : '') + '</li>';
        }).join('');
        list.classList.add('open');
      }
      function setActive(i) { var items = list.querySelectorAll('.areg-ac-opt'); for (var k = 0; k < items.length; k++) items[k].classList.remove('active'); if (i >= 0 && i < items.length) { items[i].classList.add('active'); items[i].scrollIntoView({ block: 'nearest' }); } activeIdx = i; }
      function fill(components) {
        var num = comp(components, 'street_number'), route = comp(components, 'route');
        var city = comp(components, 'locality') || comp(components, 'postal_town') || comp(components, 'sublocality') || comp(components, 'sublocality_level_1');
        var stt = comp(components, 'administrative_area_level_1'), zip = comp(components, 'postal_code');
        var street = [(num && num.longText) || '', (route && route.longText) || ''].join(' ').trim();
        if (street && byId(fields.address1)) byId(fields.address1).value = street;
        if (city && byId(fields.city)) byId(fields.city).value = city.longText;
        if (zip && byId(fields.zip)) byId(fields.zip).value = (zip.longText || '').slice(0, 5);
        if (stt && stt.shortText && byId(fields.state)) byId(fields.state).value = stt.shortText;
      }
      function choose(pred) {
        if (!pred) return;
        var place = pred.toPlace();
        place.fetchFields({ fields: ['addressComponents'] }).then(function () { fill(place.addressComponents || []); }).catch(function () {}).then(function () { token = new AutocompleteSessionToken(); closeList(); input.focus(); });
      }
      function fetchPreds(qy) {
        AutocompleteSuggestion.fetchAutocompleteSuggestions({ input: qy, sessionToken: token, includedRegionCodes: ['us'], includedPrimaryTypes: ['street_address', 'premise', 'subpremise'] })
          .then(function (res) { preds = ((res && res.suggestions) || []).map(function (s) { return s.placePrediction; }).filter(Boolean); render(); }).catch(function () {});
      }
      input.addEventListener('input', function () { var qy = input.value.trim(); clearTimeout(debounce); if (qy.length < 3) { closeList(); return; } debounce = setTimeout(function () { fetchPreds(qy); }, 200); });
      input.addEventListener('keydown', function (e) {
        if (!list.classList.contains('open')) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(activeIdx + 1, preds.length - 1)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(activeIdx - 1, 0)); }
        else if (e.key === 'Enter') { if (activeIdx >= 0 && preds[activeIdx]) { e.preventDefault(); choose(preds[activeIdx]); } }
        else if (e.key === 'Escape') { closeList(); }
      });
      list.addEventListener('mousedown', function (e) { var li = e.target.closest('.areg-ac-opt'); if (!li) return; e.preventDefault(); choose(preds[parseInt(li.getAttribute('data-i'), 10)]); });
      input.addEventListener('blur', function () { setTimeout(closeList, 150); });
    }).catch(function () { /* maps failed — manual typing still works */ });
  }

  function collectConsent() { var out = {}; qa('#areg-checks input[data-consent]').forEach(function (i) { out[i.getAttribute('data-consent')] = !!i.checked; }); return out; }
  function collectShipAddress() {
    var a = currentShipAddr(); if (!a) return null;
    return { firstName: a.firstName || '', lastName: a.lastName || '', address1: a.address1 || '', address2: a.address2 || '',
      city: a.city || '', province: a.provinceCode || '', zip: a.zip || '', phone: a.phone || '', country: 'US' };
  }

  // `confirmChange` — the second pass, after the bidder has seen which of their
  // existing bids the new choice would strand and said go ahead. Never set by
  // default: the whole point is that they are asked once.
  function submit(confirmChange) {
    if (state.submitting) return;
    showError('');
    // Every step answered and confirmed — the button is disabled until then, but a
    // step can be re-opened (and so un-confirmed) after the review was reached.
    var unfinished = (state.steps || []).filter(function (k) { return k !== 'confirm' && !(state.done[k] && stepComplete(k)); })[0];
    if (unfinished) { showError('Please finish “' + stepTitle(unfinished) + '” first.'); openStep(unfinished); return; }
    var consent = collectConsent();
    if (!consent.cardAuth || !consent.timing || !consent.cardLock || !consent.terms) { showError('Please check all of the authorization boxes to ' + (isUpdating() ? 'update your registration.' : 'register.')); return; }
    // ⚠️ The answers exactly as given — no fallback to a method, a timing or a card.
    var body = { auctionCode: state.auction, fulfillment: state.fulfillment, autoChargeMode: state.ctx.isFirstTime ? 'end_of_auction' : state.timing, consent: consent };
    if (state.fulfillment === 'shipping') {
      var a = currentShipAddr();
      if (!a || !a.address1 || !a.city || !a.provinceCode || !a.zip) { showError('Please choose or add a shipping address (street, city, state, ZIP).'); openStep('delivery'); return; }
      body.shippingAddress = collectShipAddress();
      if (a.id && !a._oneOff) body.shippingAddressId = a.id;
    } else if (state.fulfillment === 'pickup') {
      if (!state.pickupLocation) { showError('Please choose a pickup location.'); openStep('delivery'); return; }
      body.pickupLocation = state.pickupLocation;
      if (state.pickupSlot) body.pickupSlot = state.pickupSlot;
    }
    // The RSVP is sent only when it was answered HERE. A registration being changed
    // shows the answer on record, and re-sending it untouched would restamp a count
    // nobody moved. (Auction day implies "yes" server-side regardless.)
    if (state.rsvp && state.rsvpTouched) body.rsvp = state.rsvp;
    // Remember / forget these answers for future sales of this kind.
    var remBox = q('#areg-remember');
    if (remBox) body.rememberChoices = !!remBox.checked;
    if (confirmChange === true) body.confirmFulfillmentChange = true;
    var btn = q('#areg-submit'); state.submitting = true; btn.disabled = true;
    btn.textContent = isUpdating() ? 'Updating…' : 'Registering…';
    function resetBtn() { state.submitting = false; btn.disabled = false; btn.textContent = submitLabel(); }
    function fail(msg) { showError(msg); resetBtn(); }

    var cardPromise;
    if (state.cardChoice !== 'new') { body.savedCardId = state.cardChoice; cardPromise = Promise.resolve(); }
    else {
      if (!state.sq.ready || !state.sq.card) { fail('The card form isn’t ready yet. Please wait a moment and try again.'); return; }
      cardPromise = state.sq.card.tokenize().then(function (r) {
        if (r.status !== 'OK') { var ce = new Error((r.errors && r.errors[0] && r.errors[0].message) || 'Please check your card details.'); ce.step = 'card'; throw ce; }
        return state.sq.payments.verifyBuyer(r.token, { intent: 'STORE', customerInitiated: true, sellerKeyedIn: false })
          .then(function (v) { return { sourceId: r.token, verificationToken: v && v.token }; })
          .catch(function () { return { sourceId: r.token, verificationToken: null }; });
      }).then(function (c) { body.card = c; });
    }

    cardPromise.then(function () {
      return api('/auction-register', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    }).then(function (resp) {
      if (resp.status === 403 && resp.data && resp.data.error === 'PHONE_VERIFICATION_REQUIRED') {
        resetBtn();
        if (window.MHVVerify) window.MHVVerify.open({ message: 'Verify your phone number to register.', onVerified: submit });
        else showError('Please verify your phone number first.');
        return;
      }
      // ── THE NEW CHOICE WOULD STRAND A BID ALREADY PLACED ────────────────────
      // Named, not counted: "2 lots" tells the bidder nothing they can act on. The
      // bids are NEVER withdrawn — they are told what it means and asked once.
      if (resp.status === 409 && resp.data && resp.data.error === 'FULFILLMENT_CONFLICT') {
        resetBtn();
        renderConflict(resp.data);
        return;
      }
      if (!resp.ok || !resp.data || !resp.data.success) { fail((resp.data && resp.data.error) || 'Registration failed. Please try again.'); return; }
      var reg = resp.data.registration || {};
      var wasUpdate = isUpdating();
      // The card that was actually locked, for the summary below.
      state.cardChoice = null;
      state.ctx.existing = Object.assign({}, state.ctx.existing || {}, { cardBrand: reg.cardBrand, cardLast4: reg.cardLast4 });
      showDone();
      els.doneMsg.innerHTML = (wasUpdate ? 'Your registration for this auction is updated.' : 'You can now bid in this auction. Good luck!') +
        (body.rememberChoices ? '<br><span class="areg-done-how">We’ll remember these choices for future ' + rememberKind() + ' auctions.</span>' : '') +
        '<div class="areg-review areg-review--done">' + reviewRowsHtml(false) + '</div>';
      els.card.scrollTop = 0;
    }).catch(function (e) {
      if (e && e.step === 'card') { state.done.card = false; openStep('card'); }
      fail((e && e.message) || 'Registration failed. Please try again.');
    });
  }

  // The conflict sheet. Rendered INTO the error slot's place at the top of the form
  // rather than as a second modal — the form they are about to re-submit is right
  // there underneath, and a modal over a modal is a dead end on a phone.
  function renderConflict(data) {
    var list = (data.conflicts || []).map(function (c) {
      return '<li><b>Lot ' + esc(c.lot || '?') + '</b> — ' + esc(c.restriction || 'restricted') + '</li>';
    }).join('');
    var wrap = document.createElement('div');
    wrap.className = 'areg-callout areg-callout--warn';
    wrap.id = 'areg-conflict';
    wrap.innerHTML =
      '<p style="margin:0 0 6px;"><b>⚠️ ' + esc(data.message || 'Some of your bids don’t match this choice.') + '</b></p>' +
      '<ul class="areg-conflict-list">' + list + '</ul>' +
      '<p style="margin:8px 0 10px;">Your bids stay exactly as they are. If you win one of these lots you’ll need to ' +
      'collect it where it’s held — call us on (603) 451-6960 and we’ll sort it out with you.</p>' +
      '<button type="button" class="areg-btn areg-btn--sm" id="areg-conflict-go">Change it anyway</button> ' +
      '<button type="button" class="areg-link" id="areg-conflict-back">Go back</button>';
    var existing = document.getElementById('areg-conflict');
    if (existing) existing.parentNode.removeChild(existing);
    els.body.insertAdjacentElement('afterbegin', wrap);
    els.card.scrollTop = 0;
    wrap.querySelector('#areg-conflict-go').addEventListener('click', function () { submit(true); });
    wrap.querySelector('#areg-conflict-back').addEventListener('click', function () {
      wrap.parentNode.removeChild(wrap);
    });
  }

  window.MHVAuctionRegister = { open: open, close: close };
})();
